import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';

export default function ServerListGroup() {
  return (
    <Card style={{ width: '18rem', height: '25rem' }}>
      <Card.Header>서버목록</Card.Header>
      <ListGroup variant="flush" style={{ overflowY: 'auto' }}>
        <ListGroup.Item>1번 서버</ListGroup.Item>
        <ListGroup.Item>2번 서버</ListGroup.Item>
        <ListGroup.Item>3번 서버</ListGroup.Item>
        <ListGroup.Item>4번 서버</ListGroup.Item>
        <ListGroup.Item>5번 서버</ListGroup.Item>
        <ListGroup.Item>6번 서버</ListGroup.Item>
        <ListGroup.Item>7번 서버</ListGroup.Item>
        <ListGroup.Item>8번 서버</ListGroup.Item>
        <ListGroup.Item>9번 서버</ListGroup.Item>
        <ListGroup.Item>10번 서버</ListGroup.Item>
        <ListGroup.Item>11번 서버</ListGroup.Item>
        <ListGroup.Item>12번 서버</ListGroup.Item>
      </ListGroup>
      <div className='d-flex justify-content-end m-1'>
      <Button variant="flush">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrows-angle-expand" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"/>
        </svg>
      </Button>
      </div>
    </Card>
  );
}